import { render, staticRenderFns } from "./EssaySendForm.vue?vue&type=template&id=fa5153a2&scoped=true&"
import script from "./EssaySendForm.vue?vue&type=script&lang=ts&"
export * from "./EssaySendForm.vue?vue&type=script&lang=ts&"
import style0 from "./EssaySendForm.vue?vue&type=style&index=0&id=fa5153a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5153a2",
  null
  
)

export default component.exports